module.exports = __webpack_public_path__ + "static/media/contactlenses.0fa76ab2.pdf";